/**
 * JWNETデータ取込
 * 自動紐付更新
 */
import Vue from "vue";
import * as httpConst from "@/constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/transfers/auto_configurations`;

const getDefaultState = () => {
  return {}
};

const transferAutoConfiguration = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    /**
     * 自動紐付け更新
     * @param commit
     * @param params
     * @param params.searched_at { Number } 検索実行日時
     */
    update({commit}, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.patch(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    }
  }
};


export default transferAutoConfiguration;
